class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.initHover();
  }

  initHover() {
    if (!this.mainDetailsToggle) return;
    let leaveTimer = null;
    let closeAnimationTimer = null;

    const openMenu = () => {
      if (window.innerWidth < 990) return;
      if (leaveTimer) {
        clearTimeout(leaveTimer);
        leaveTimer = null;
      }
      if (closeAnimationTimer) {
        clearTimeout(closeAnimationTimer);
        closeAnimationTimer = null;
      }
      this.mainDetailsToggle.classList.remove('menu-closing');

      // Close other opened header menus
      document.querySelectorAll('header-menu details[open]').forEach((det) => {
        if (det !== this.mainDetailsToggle) {
          det.classList.remove('menu-closing');
          det.removeAttribute('open');
          const sum = det.querySelector('summary');
          if (sum) sum.setAttribute('aria-expanded', 'false');
        }
      });
      if (!this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.setAttribute('open', '');
        const summary = this.mainDetailsToggle.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
        this.onToggle();
      }
    };

    const closeMenu = () => {
      if (window.innerWidth < 990) return;
      leaveTimer = setTimeout(() => {
        if (!this.mainDetailsToggle.hasAttribute('open')) return;
        this.mainDetailsToggle.classList.add('menu-closing');
        closeAnimationTimer = setTimeout(() => {
          this.close();
          this.mainDetailsToggle.classList.remove('menu-closing');
          closeAnimationTimer = null;
        }, 140);
      }, 150);
    };

    this.addEventListener('mouseenter', openMenu);
    this.addEventListener('mouseleave', closeMenu);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
